
import { Component, OnInit, ViewEncapsulation, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { WidgetService } from '../../services/widget/widget.service';
import { CommonService } from '../../services/common/common.service';
import { UserService } from "../../services/user/user.service";
import { Observable, ReplaySubject } from 'rxjs';
import { ISubscription } from "rxjs/Subscription";
import * as moment from "moment";
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-graph',
  templateUrl: './graph.component.html',
  styleUrls: ['./graph.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GraphComponent implements OnInit, OnDestroy {
  @Input('graphId') graphId: number;
  @Input('wigetData') wigetData: any;
  @Input('groupId') groupId: any;
  @Input('groupData') groupDataActual: any;
  @Input('isEditable') isEditable: any;
  @Input('showEdit') showEdit: any;
  @Output()
  onKpiResponse: EventEmitter<{ Response: '', widgetId: '' }> = new EventEmitter<{ Response: '', widgetId: '' }>();

  @Output()
  onSiteEmitResponse: EventEmitter<{ response: any, widgetId: '' }> = new EventEmitter<{ response: any, widgetId: '' }>();
  groupData: any = {};
  graphData: any = { timeFrame: "", kpiType: "", fetchDataFor: "", dataFilter: "", events: "", binFilter: "" };
  componentData: any = { timeFrame: "", kpiType: "", fetchDataFor: "", dataFilter: "", events: "", binFilter: "" };
  segmentData: any = [];
  refreshGroupInterval: ISubscription;
  _indexDatabase: any;
  isGraphLoaded: boolean = true;
  userOffSet: string;
  reqestSampleBody;
  private _unsubscribeAll  : ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  constructor(
    private widgetService: WidgetService,
    private commonService: CommonService,
    private userService: UserService
  ) { }

  ngOnInit() {
    //get User offset    
    let userOff = this.userService.getLoggedInUser();
    this.userOffSet = userOff.settings.localOffSet;

    this.groupData = Object.assign({}, this.groupDataActual);
    this.wigetData.isPredictiveSearch = (Boolean(this.groupData.isPredictive) && userOff.settings.predictiveAnalytics == "1");
    //if widget is sitemap widget then don't hit api
    //later we have to make it like count and show count on site
    if (this.wigetData.kpiType == "siteMap") {
      this.graphData.kpiType = this.wigetData.kpiType;
      this.graphData.fetchDataFor = this.wigetData.fetchDataFor;
      this.graphData.dataFilter = this.wigetData.dataFilter;
      this.graphData.udf = { widgetId: this.wigetData._id };
      return;
    }
    if(this.wigetData.kpiType == "richText"){
      this.isGraphLoaded = false;
      return;
    }
    this.getSegmentsList();
    this.commonService.connectIdxDB().then(dbConn => {
      this._indexDatabase = dbConn;
      this.getWidgetData();
    })

  }

  ngOnDestroy() {
    if (this.refreshGroupInterval)
      this.refreshGroupInterval.unsubscribe();
    this._unsubscribeAll.next(true);
    this._unsubscribeAll.complete();
  }

  getWidgetData() {
    //create request body    
    let requestBody: any = {};
    //ripun
    this.commonService.readIdWidget(this._indexDatabase, this.wigetData._id).then(item => {
      if (item && this.wigetData.dataFilter.length > 0) {
        let kpiFormat = this.wigetData.dataFilter.map((obj) => {
          var a = {};
          a["kpiNumberFormat"] = obj.kpiNumberFormat ? obj.kpiNumberFormat : 0;
          a["kpiNumericConfig"] = obj.kpiNumericConfig ? obj.kpiNumericConfig : { showNumericConfig: false };
          a["suffixLabel"] = obj.suffixLabel ? obj.suffixLabel : "";
          a["prefixLabel"] = obj.prefixLabel ? obj.prefixLabel : "";
          return a;
        });
        let res = item['_data'];
        this.graphData = res;
        this.componentData = res;
        this.commonService.sendAction("Advertising_Id", { widgetId: res.udf.widgetId, isAdvertising_Id: (res && res.dataFilter && res.dataFilter.length > 0 && res.dataFilter[0].data.length > 0) });
        this.onKpiResponse.emit({ Response: res, widgetId: this.wigetData._id });
        if (res && res.dataFilter && res.dataFilter.length > 0 && kpiFormat) {
          kpiFormat = this.kpiFormatList(res.dataFilter.length, kpiFormat);
          this.graphData.udf.kpiNumberConfig = kpiFormat;
          this.componentData.udf.kpiNumberConfig = kpiFormat;
        }
        this.isGraphLoaded = false;
      }
      else {
        requestBody.kpiType = this.wigetData.kpiType;
        requestBody.fetchDataFor = this.wigetData.fetchDataFor;
        requestBody.isPredictiveSearch = this.wigetData.isPredictiveSearch;        
        if (requestBody.kpiType == 'histogram')
          requestBody.binFilter = this.wigetData.binFilter;
        if (this.wigetData.kpiType == "visual" && this.wigetData.fetchDataFor == "staticLayoutMap") {
          requestBody.dataFilter = this.wigetData.dataFilter;
        } else {
          requestBody.dataFilter = this.buildDataFilterForRequest();
        }

        //set the date in from and to
        //, 'MTD', 'YTD', 'WTD'
        if (!['Custom'].includes(this.groupData.dateType)) {
          // if (this.groupData.dateType != "Custom") {
          if (!this.groupData.to) {
            this.groupData.to = new Date();
          }
          let dateObj = this.commonService.convertDate(this.groupData.dateType, this.groupData.from, this.groupData.to, 1);
          this.groupData.from = dateObj.firstDay;
          this.groupData.to = dateObj.lastDay;
          if (['WTD', 'MTD', 'YTD'].includes(this.groupData.dateType)) {
            this.groupData.to = this.commonService.getDateConverted(dateObj.lastDay, "YYYY-MM-DD HH:mm:ss");
          }
        }

        if (this.wigetData.kpiType == "trend") {
          let currentDate = moment().startOf('day').format("YYYY-MM-DD HH:mm:ss");
          let trendFrom = this.groupData.showTrend ? this.groupData.trendFrom : currentDate || currentDate;

          let dateObj = this.commonService.convertDate("Trend Date", trendFrom, "", 1);

          this.groupData.from = dateObj.firstDay;
          this.groupData.to = dateObj.lastDay;

          // console.log(this.groupData.from,this.groupData.to);
        }


        requestBody.from = this.groupData.from//moment.utc(this.groupData.from).format("YYYY-MM-DD HH:mm:ss"); //this.groupData.from;
        requestBody.to = this.groupData.to//moment.utc(this.groupData.to).format("YYYY-MM-DD HH:mm:ss");//this.groupData.to;
        requestBody.timeFrame = this.groupData.groupByTimeFrame;

        // if (this.groupData.showDataByOperationalHours && ['count', 'numeric'].includes(this.wigetData.kpiType) && this.groupData.groupByTimeFrame == "hour") {
        //   requestBody.showSpecificDate = this.groupData.showSpecificDate && this.groupData.showSpecificDate.length > 0 ? this.groupData.showSpecificDate : this.groupData.operationHours;
        // }
        // else {
        //   requestBody.showSpecificDate = this.groupData.showSpecificDate;
        // }
        requestBody.showSpecificDate = this.groupData.showSpecificDate;
        //it will split data by site
        requestBody.consolidateSiteData = this.groupData.consolidateSiteData;
        if (this.wigetData.fetchDataFor == "performers") {
          requestBody.consolidateSiteData = 0;
        }

        //it will split data by date, week, month and year
        requestBody.consolidateData = this.groupData.consolidateData;
        requestBody.consolidateDate = this.groupData.consolidateDate || 0;
        requestBody.showDataByOperationalHours = this.groupData.showDataByOperationalHours;
        if (requestBody.showDataByOperationalHours == "") {
          requestBody.showDataByOperationalHours = 0;
        }

        //add extra data
        //debugger;
        requestBody.title = this.wigetData.title;
        //Exctract number format for KPI's
        let kpiFormat = this.wigetData.dataFilter.map((obj) => {
          var a = {};
          a["kpiNumberFormat"] = obj.kpiNumberFormat ? obj.kpiNumberFormat : 0;
          a["kpiNumericConfig"] = obj.kpiNumericConfig ? obj.kpiNumericConfig : { showNumericConfig: false };
          a["suffixLabel"] = obj.suffixLabel ? obj.suffixLabel : "";
          a["prefixLabel"] = obj.prefixLabel ? obj.prefixLabel : "";
          return a;
        });
        let geoFormat = this.wigetData.dataFilter.map((obj) => {
          // var a = {};
          // a["kpiNumberFormat"] = obj.kpiNumberFormat ? obj.kpiNumberFormat : 0;
          // a["kpiNumericConfig"] = obj.kpiNumericConfig ? obj.kpiNumericConfig : { showNumericConfig: false };
          // a["suffixLabel"] = obj.suffixLabel ? obj.suffixLabel : "";
          // a["prefixLabel"] = obj.prefixLabel ? obj.prefixLabel : "";
          return obj.geoConfig;
        });
        requestBody.dataFilter.map((obj, idx) => {
          //let arrGeo =[]; arrGeo.push()
          obj.geoConfig = geoFormat[idx];
        });
        kpiFormat = this.kpiFormatList(requestBody.dataFilter.length, kpiFormat);
        requestBody.udf = {
          widgetId: this.wigetData._id,
          axisConfig: this.wigetData.axisConfig,
          trendConfig: this.wigetData.trendConfig || {},
          countConfig: this.wigetData.countConfig,
          visualConfig: this.wigetData.visualConfig,
          numericConfig: this.wigetData.numericConfig || {},
          performerConfig: this.wigetData.performerConfig || {},
          histogramConfig: this.wigetData.histogramConfig || {},
          consolidateData: this.groupData.consolidateData,
          consolidateDate: this.groupData.consolidateDate || 0,
          showSpecificDate: this.groupData.showSpecificDate,
          kpiNumberConfig: kpiFormat,
          geoConfig: geoFormat,
          compareConfig: this.wigetData.compareConfig || {},
          compareDateConfig: this.wigetData.compareDateConfig || {},
          isRowTotal: (this.wigetData.hasOwnProperty('isRowTotal') ? this.wigetData.isRowTotal : true),
          isColumnTotal: (this.wigetData.hasOwnProperty('isColumnTotal') ? this.wigetData.isColumnTotal : true),
          isAdjustHeader: (this.wigetData.hasOwnProperty('isAdjustHeader') ? this.wigetData.isAdjustHeader : false)
        };

        //moved to common service
        requestBody.localTimezone = this.userOffSet; //userP.settings.localOffSet;
        // console.log("User offset",requestBody.localTimezone);
        //this.commonService.getLocalTimeOffSet();

        //store request body for count (trend)
        this.reqestSampleBody = requestBody;
        this.widgetService.kpiData(requestBody).pipe(takeUntil(this._unsubscribeAll)).subscribe(
          res => {
            let _isCustom = false;
            if (this.wigetData.kpiType === "comparison")
              _isCustom = (this.wigetData.compareConfig.compareType === 'periodOver' && this.wigetData.compareConfig.eventId == 'Custom') ? true : false;
            else
              _isCustom = ['Custom'].includes(this.groupData.dateType);

            this.commonService.insertWidgetData(this._indexDatabase, {
              widgetId: this.wigetData._id,
              _data: res,
              isCustomRange: _isCustom
            });
            this.graphData = res;
            this.componentData = res;
            this.commonService.sendAction("Advertising_Id", { widgetId: res.udf.widgetId, isAdvertising_Id: (res && res.dataFilter && res.dataFilter.length > 0 && res.dataFilter[0].data.length > 0) });
            this.onKpiResponse.emit({ Response: res, widgetId: this.wigetData._id });
            if (res && res.dataFilter && res.dataFilter.length > 0 && kpiFormat) {
              kpiFormat = this.kpiFormatList(res.dataFilter.length, kpiFormat);
              this.graphData.udf.kpiNumberConfig = kpiFormat;
              this.componentData.udf.kpiNumberConfig = kpiFormat;
            }
            let timeOutInterval = ["count", "trend", "siteMap"].includes(res.kpiType) ? 0 : 2500 || 2500;
            setTimeout(() => {
              this.isGraphLoaded = false;
            }, timeOutInterval);
          },
          (err) => { }
        );
        // console.log("refresh group",requestBody);

        //refresh data
        if (this.groupData.refreshGroup > 0) {
          this.refreshGroupInterval = Observable.interval(this.groupData.refreshGroup * 1000 + 3000).pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            this.widgetService.kpiData(requestBody).pipe(takeUntil(this._unsubscribeAll)).subscribe(
              res => {
                this.graphData = res;
                this.componentData = res;
              },
              (err) => { }
            )
          });
        }
      }
    })
  }

  kpiFormatList(dataFilterLength, kpiFormatter) {
    let kpiFormatList = [];
    if (dataFilterLength > 0 && kpiFormatter && kpiFormatter.length > 0) {
      //kpiFormatList should have this much length value
      let kpiLength = dataFilterLength / kpiFormatter.length;
      kpiFormatter.forEach((element, i) => {
        for (let j = 0; j < kpiLength; j++)
          kpiFormatList.push(element)
      });
    }
    return kpiFormatList;
  }


  buildDataFilterForRequest() {

    let dataFilterFinal = this.wigetData.dataFilter;

    //if widget is effected by group filter
    if (this.wigetData.isEffectedByGroupFilter) {
      let dataFilter = [];
      //prepare datafilter for request
      this.wigetData.dataFilter.forEach((filter, index) => {
        filter.fetchDataFor = filter.fetchDataFor == undefined ? this.wigetData.fetchDataFor : filter.fetchDataFor;
        let tempFilter = {
          kpiGroupId: filter.kpiGroupId,
          fetchDataFor: filter.fetchDataFor,
          kpiId: filter.kpiId,
          elementId: filter.elementId,
          label: filter.label,
          isThousandSeperator: filter.isThousandSeperator,
          isRowTotal: filter.isRowTotal,
          isAdjustHeader: filter.isAdjustHeader,
          isColumnTotal: filter.isColumnTotal,
          color: this.getColorTheme(filter.color, 0),
          showOnAxis: filter.showOnAxis,
          mapped: [],
          actual: filter.actual,
          predictive: filter.predictive,
          segId: filter.segId,
          displayType: filter.displayType
        };

        //if filter is consolidated or kpi type if count
        //consolidateSiteData - if it is true then create only one datafilter with array of siteid in map key
        //count - we need only one datafilter to be created
        if (this.groupData.consolidateSiteData || this.wigetData.kpiType == "count" || this.wigetData.kpiType == "trend" || (this.wigetData.kpiType == "comparison" && this.wigetData.compareConfig.fetchDataFor == "count" && this.wigetData.compareConfig.compareType != 'events')) {

          //if site data is available then use sites as filter
          if (this.groupData.sites && this.groupData.sites.length > 0) {
            this.groupData.sites.forEach((site, i) => {
              let tempMapped = {};
              tempMapped["siteId"] = site;
              tempMapped["mappedFullSite"] = this.groupData.mappedFullSite;
              // tempMapped["devices"] = this.groupData.devices || [];
              tempMapped["brands"] = [];
              //if mapped fullsite is 1 then set empty zone or set zone
              if (this.groupData.mappedFullSite == 1) {
                tempMapped["zones"] = [];
                tempMapped["devices"] = [];
              }else if(this.groupData.mappedFullSite == 2){
                tempMapped["zones"] = [];
                tempMapped["devices"] = this.groupData.devices.map(d => {
                  let ds = d.split("|");
                  if (ds.length == 2) {
                    return ds[1];
                  }
                  return ds[0];
                });
              } else {
                tempMapped["devices"] = [];
                tempMapped["zones"] = this.groupData.zones.map(z => {
                  let zs = z.split("|");
                  if (zs.length == 2) {
                    return zs[1];
                  }
                  return zs[0];
                });
              }
              tempFilter.mapped.push(tempMapped);
            })
          }


          //or if brands data is avaialble use brands as filter
          else if (this.groupData.brands && this.groupData.brands.length > 0) {
            // add brands into the tempmapped object
            let tempMapped = {};
            tempMapped["siteId"] = "";
            tempMapped["mappedFullSite"] = 0;
            tempMapped["devices"] = [];
            tempMapped["brands"] = this.groupData.brands;
            tempMapped["zones"] = [];
            //push temMapped into tempfilter
            tempFilter.mapped.push(tempMapped);
          }


          //push tempFilter into dataFilter
          dataFilter.push(tempFilter);
        }


        //if filter is not consolidated or kpi type is not count
        //consolidateSiteData - if it is false then create multiple datafilter with single siteid or brandid in map key
        //if mapFullSite is 0 then create single zone data filter
        //count - count should have only one data filter consolidate site data key should not effect site thats why not allowing count here
        else if (this.groupData.consolidateSiteData == 0 && this.wigetData.kpiType != "count" && this.wigetData.kpiType != "trend") {

          //if site data is available then use sites as filter
          if (this.groupData.sites && this.groupData.sites.length > 0 && this.groupData.mappedFullSite == 1 && this.groupData.brands.length == 0) {
            this.groupData.sites.forEach((site, i) => {
              tempFilter = {
                kpiGroupId: filter.kpiGroupId,
                fetchDataFor: filter.fetchDataFor,
                kpiId: filter.kpiId,
                elementId: filter.elementId,
                label: filter.label,
                isThousandSeperator: filter.isThousandSeperator,
                isRowTotal: filter.isRowTotal,
                isAdjustHeader: filter.isAdjustHeader,
                isColumnTotal: filter.isColumnTotal,
                color: this.getColorTheme(filter.color, i),
                showOnAxis: filter.showOnAxis,
                mapped: [],
                actual: (typeof filter.actual != 'undefined' ? filter.actual : true),
                predictive: (typeof filter.predictive != 'undefined' ? filter.predictive : false),
                segId: (typeof filter.segId != 'undefined' ? filter.segId : []),
                displayType: filter.displayType
              };
              tempFilter.mapped[0] = {};
              tempFilter.mapped[0]["siteId"] = site;
              tempFilter.mapped[0]["mappedFullSite"] = this.groupData.mappedFullSite;
              tempFilter.mapped[0]["devices"] = [];
              tempFilter.mapped[0]["brands"] = [];
              if (this.groupData.mappedFullSite) {
                tempFilter.mapped[0]["zones"] = [];
              } else {
                tempFilter.mapped[0]["zones"] = this.groupData.zones;
              }
              dataFilter.push(tempFilter);
            })
          }

          //if mappedFullSite is 0 then it will build datafilter with one zone id
          else if (this.groupData.zones && this.groupData.zones.length > 0 && this.groupData.mappedFullSite == 0) {
            this.groupData.zones.forEach((zone, i) => {
              zone = zone.split("|");
              if (zone.length != 2) {
                return;
              }

              let siteId = zone[0];
              let zoneId = zone[1];

              tempFilter = {
                kpiGroupId: filter.kpiGroupId,
                fetchDataFor: filter.fetchDataFor,
                kpiId: filter.kpiId,
                elementId: filter.elementId,
                label: filter.label,
                isThousandSeperator: filter.isThousandSeperator,
                isRowTotal: filter.isRowTotal,
                isAdjustHeader: filter.isAdjustHeader,
                isColumnTotal: filter.isColumnTotal,
                color: this.getColorTheme(filter.color, i),
                showOnAxis: filter.showOnAxis,
                mapped: [],
                actual: (typeof filter.actual != 'undefined' ? filter.actual : true),
                predictive: (typeof filter.predictive != 'undefined' ? filter.predictive : false),
                segId: (typeof filter.segId != 'undefined' ? filter.segId : []),
                displayType: filter.displayType
              };
              tempFilter.mapped[0] = {};
              tempFilter.mapped[0]["siteId"] = siteId;
              tempFilter.mapped[0]["mappedFullSite"] = this.groupData.mappedFullSite;
              tempFilter.mapped[0]["devices"] = [];
              tempFilter.mapped[0]["brands"] = [];
              tempFilter.mapped[0]["zones"] = [];
              tempFilter.mapped[0]["zones"].push(zoneId);

              dataFilter.push(tempFilter);
            })
          }

          //if mappedFullSite is 2 then it will build datafilter with one device id
          else if (this.groupData.devices && this.groupData.devices.length > 0 && this.groupData.mappedFullSite == 2) {
            this.groupData.devices.forEach((device, i) => {
              device = device.split("|");
              if (device.length != 2) {
                return;
              }

              let siteId = device[0];
              let deviceId = device[1];

              tempFilter = {
                kpiGroupId: filter.kpiGroupId,
                fetchDataFor: filter.fetchDataFor,
                kpiId: filter.kpiId,
                elementId: filter.elementId,
                label: filter.label,
                isThousandSeperator: filter.isThousandSeperator,
                isRowTotal: filter.isRowTotal,
                isAdjustHeader: filter.isAdjustHeader,
                isColumnTotal: filter.isColumnTotal,
                color: this.getColorTheme(filter.color, i),
                showOnAxis: filter.showOnAxis,
                mapped: [],
                actual: (typeof filter.actual != 'undefined' ? filter.actual : true),
                predictive: (typeof filter.predictive != 'undefined' ? filter.predictive : false),
                segId: (typeof filter.segId != 'undefined' ? filter.segId : []),
                displayType: filter.displayType
              };
              tempFilter.mapped[0] = {};
              tempFilter.mapped[0]["siteId"] = siteId;
              tempFilter.mapped[0]["mappedFullSite"] = this.groupData.mappedFullSite;
              tempFilter.mapped[0]["devices"] = [];
              tempFilter.mapped[0]["brands"] = [];
              tempFilter.mapped[0]["zones"] = [];
              tempFilter.mapped[0]["devices"].push(deviceId);

              dataFilter.push(tempFilter);
            })
          }

          //or if brands data is avaialble use brands as filter
          else if (this.groupData.brands && this.groupData.brands.length > 0) {
            this.groupData.brands.forEach((brand, i) => {
              this.groupData.sites.filter(x=>x!='full').forEach((site, x) => {
                tempFilter = {
                  kpiGroupId: filter.kpiGroupId,
                  fetchDataFor: filter.fetchDataFor,
                  kpiId: filter.kpiId,
                  elementId: filter.elementId,
                  label: filter.label,
                  isThousandSeperator: filter.isThousandSeperator,
                  isRowTotal: filter.isRowTotal,
                  isAdjustHeader: filter.isAdjustHeader,
                  isColumnTotal: filter.isColumnTotal,
                  color: this.getColorTheme(filter.color, x+i),
                  showOnAxis: filter.showOnAxis,
                  mapped: [],
                  actual: (typeof filter.actual != 'undefined' ? filter.actual : true),
                  predictive: (typeof filter.predictive != 'undefined' ? filter.predictive : false),
                  segId: (typeof filter.segId != 'undefined' ? filter.segId : []),
                  displayType: filter.displayType
                };
                tempFilter.mapped[0] = {};
                tempFilter.mapped[0]["siteId"] =site;
                tempFilter.mapped[0]["mappedFullSite"] = 1;
                tempFilter.mapped[0]["devices"] = [];
                tempFilter.mapped[0]["brands"] = [brand];
                tempFilter.mapped[0]["zones"] = [];

                dataFilter.push(tempFilter);
              });
            });
          }

        }
      })

      //replaced datafilter in request body
      dataFilterFinal = dataFilter;
    }

    return dataFilterFinal;
  }

  getColorTheme(color, i) {
    let colorHex = "#ADD9FE";

    //using same color theme in backend
    const colorTheme = {
      "#E7126E": ["#E7126E", "#FF1803", "#F9667A", "#FF6057", "#EB3E5C", "#DA1131", "#CD1459", "#F87B9F", "#FF4B86", "#E81345", "#F5B4C5", "#FF3396", "#B00C3E", "#E64C83"],
      "#007690": ["#007690", "#0FA3A2", "#11BEB3", "#549C9D", "#45E6D8", "#8DFEDE", "#00FDFF", "#55D0AB", "#40FEE2", "#55FED5", "#92EFE7", "#9BE7F1", "#BAFEFF", "#9BE7F1"],
      "#002750": ["#002750", "#36439A", "#162E9E", "#1C3CD3", "#3773D1", "#4F79F9", "#305FE9", "#65A2FB", "#0090F3", "#1A52A7", "#1A52A7", "#1A52A7", "#5E9DDB", "#008CDC"],
      "#7F186E": ["#7F186E", "#83366D", "#902F64", "#96345C", "#AF1F6D", "#C14C8A", "#AF1F6D", "#742365", "#AF1F6D", "#79248B", "#AF1F6D", "#79248B", "#B33D92", "#AD88BF"],
      //Cyan 50
      "#ADD9FE": ["#ADD9FE", "#E0F7FA", "#B2EBF2", "#80DEEA", "#4DD0E1", "#26C6DA", "#00BCD4", "#00ACC1", "#0097A7", "#00838F", "#006064", "#84FFFF", "#18FFFF", "#00E5FF", "#00B8D4"],

      //Lime 50
      "#FFC046": ["#FFC046", "#F9FBE7", "#F0F4C3", "#E6EE9C", "#DCE775", "#D4E157", "#CDDC39", "#F4FF81", "#EEFF41"],

      //Pink 50
      "#FFCDD2": ["#FFCDD2", "#FCE4EC", "#F8BBD0", "#F48FB1", "#F06292"],


      //Teal 50
      "#77DD77": ["#77DD77", "#E0F2F1", "#B2DFDB", "#80CBC4", "#4DB6AC", "#26A69A", "#A7FFEB", "#64FFDA", "#1DE9B6"],

      //Gray 50
      "#FAFAFA": ["#FAFAFA", "#F5F5F5", "#EEEEEE", "#E0E0E0", "#BDBDBD", "#9E9E9E", "#424242", "#CFD8DC", "#B0BEC5", "#90A4AE", "#607D8B"],

      //Deep Orange 50
      "#FBE9E7": ["#FBE9E7", "#FFCCBC", "#FFAB91", "#FF8A65", "#FF9E80", "#FF6E40"],

      //Indigo 50
      "#E8EAF6": ["#E8EAF6", "#C5CAE9", "#9FA8DA", "#8C9EFF", "#7986CB", "#5C6BC0"],

      //Light Blue 50
      "#E1F5FE": ["#E1F5FE", "#B3E5FC", "#81D4FA", "#4FC3F7", "#80D8FF", "#40C4FF", "#00B0FF"],

      //Light Green 50
      "#F1F8E9": ["#F1F8E9", "#DCEDC8", "#C5E1A5", "#AED581", "#9CCC65", "#CCFF90", "#B2FF59", "#64DD17"],

      //Brown 50
      "#EFEBE9": ["#EFEBE9", "#D7CCC8", "#BCAAA4", "#A1887F", "#8D6E63"],

      //Black
      "#000000": ["#000000", "#000000", "#000000", "#000000", "#000000", "#000000", "#000000", "#000000", "#000000", "#000000", "#000000"],

      //White
      "#FFFFFF": ["#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"]
    };

    try {
      const hexLength = colorTheme[color].length;
      const remainder = i % hexLength;
      colorHex = colorTheme[color][remainder];
    } catch (err) {
      colorHex = color ? color : colorHex;
    }

    return colorHex;
  }


  onSiteEmit(response) {
    this.onSiteEmitResponse.emit(response);
  }

  getSegmentsList() {
    // this.groupService.getGeoSegments().subscribe(r => {
    //   this.segmentData = r;
    // });
  }




}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/graph.component.ts